import { render } from "./AlertInfoModal.vue?vue&type=template&id=a2c594c6&scoped=true"
import script from "./AlertInfoModal.vue?vue&type=script&lang=js"
export * from "./AlertInfoModal.vue?vue&type=script&lang=js"

import "./AlertInfoModal.vue?vue&type=style&index=0&id=a2c594c6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c594c6"]])

export default __exports__